import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { Migalha } from 'models/migalha';
import { MigalhasService } from 'app/shared/migalhas/migalhas.service';
import { DoutoradoService } from '../service/doutorado.service';
import { MetaService } from '@ngx-meta/core';
import { StringUtilsService } from 'app/shared/string-utils.service';
import { HOST } from 'app/config';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { environment } from 'environments/environment';

@Component({
  selector: 'cm-detalhe-curso',
  templateUrl: './detalhe-curso.component.html',
  styleUrls: ['./detalhe-curso.component.scss'],
  animations: [routerTransition],
})
export class DetalheCursoComponent implements OnInit, OnDestroy {
  environment = environment;
  loading: boolean = true;

  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  url: BehaviorSubject<string> = new BehaviorSubject<string>('');
  routerObserver: Subscription;
  migalhasObserver: Subscription;
  cursoSelecionado: any;
  migalhas: Migalha[];
  cursoIdentificador: string;
  cursoCarregando = true;

  detalhesCurso: Object[] = [];
  detalhesCursoFamaz = {};

  baseMenuLateral = {
    nome: 'Doutorado',
    link: '/pos-graduacao/doutorado/',
  };

  baseMenuLateralMobile = {
    nome: 'Menu ',
    link: '',
  };

  menuLateral = [
    {
      nome: 'Sobre o programa',
      link: 'sobre-o-programa',
      templateLink: this.gerarTemplateLink('sobre-o-programa'),
    },

  ];

  constructor(
    private router: Router,
    private migalhasService: MigalhasService,
    private doutoradoService: DoutoradoService,
    private readonly meta: MetaService,
    private stringUtil: StringUtilsService,
    private route: ActivatedRoute
  ) {
    const migalhaRaiz = new Migalha(this.baseMenuLateral);
    migalhaRaiz.submenu = Migalha.construirArray(this.menuLateral);

    this.migalhasObserver = this.migalhasService
        .iniciar([migalhaRaiz])
        .subscribe((dados) => {
          this.migalhas = dados;
        });
    this.routerObserver = this.router.events
        .filter(event => event instanceof NavigationEnd)
        .subscribe((event: NavigationEnd) => {
            this.url.next(this.router.url);
            this.migalhasService.novaUrl(this.router.url);
            this.onNavegacaoURL(event.url);
        });

   }

   ngOnInit() {
    this.getCursoDetalheFamaz()
   }

   async getCursoDetalheFamaz() {
    let codigoCurso: string

    this.route.params.subscribe(params => {
      const curso = params['curso']
      codigoCurso = curso
    })

    if (environment.loginContexto === 'FAMAZ') {
      await this.doutoradoService.getCursosFamazPerId(Number(codigoCurso)).then(curso => {
        this.detalhesCursoFamaz = curso[0]
        console.log(curso)
      })
    }

    this.loading = false;
   }

   async onNavegacaoURL(url) {
    const regexDoutorado = /\/pos-graduacao\/doutorado\/(\d{1,4})-(.*)/;
    const urlDetalhes = regexDoutorado.exec(url);

    if (urlDetalhes[1] && this.cursoIdentificador !== urlDetalhes[1]) {

      this.cursoIdentificador = urlDetalhes[1];

      if (environment.loginContexto === 'FAMAZ') {
        // await this.doutoradoService.getCursosFamazPerId(this.cursoIdentificador).then(curso => {
        //   this.detalhesCursoFamaz = curso
        //   console.log(curso)
        // })
      } else {
        this.doutoradoService.listCursoDoutoradoId(this.cursoIdentificador).subscribe(cursoConteudo => {
            console.log(cursoConteudo);
            const detalhesCurso = this.detalhesCurso = cursoConteudo.cursosposgraduacao;
            this.baseMenuLateralMobile.nome += this.stringUtil.compactarNome(detalhesCurso[0].nome);
            this.cursoSelecionado = detalhesCurso;

            this.migalhas.push({
              nome: this.cursoSelecionado[0].nome,
              link: '/pos-graduacao/doutorado',
            });

            if (detalhesCurso[0].linksExtras) {
              this.menuLateral = [
                ...this.menuLateral,
                ...detalhesCurso[0].linksExtras.map(extraLink => ({ nome: extraLink.nome, link: extraLink.link })),
              ];
            }


          // setting meta tags
          this.meta.setTitle(`${this.cursoSelecionado[0].nome} no Ceuma`);
          this.meta.setTag('og:description', this.cursoSelecionado[0].ogdescription);
          this.meta.setTag('og:image', `${HOST}/assets/images/pos-graduacao/${this.cursoIdentificador}.png`);
          this.cursoCarregando = false;

        });
      }
    }

   }

  gerarTemplateLink(link) {
    return new RegExp(`^\/pos-graduacao\/doutorado\/?([^\/]*)\/${link}(#.*)?$`, 'i');
  }

  ngOnDestroy() {
    if (this.routerObserver) {
      this.routerObserver.unsubscribe();
    }
    if (this.migalhasObserver) {
      this.migalhasObserver.unsubscribe();
    }
  }

}
